import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only send cookies when enabled by environment
    if (environment.sendCredentials) {
      const withCreds = req.withCredentials ? req : req.clone({ withCredentials: true });
      return next.handle(withCreds);
    }
    return next.handle(req);
  }
}
